import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { Logo } from './Logo';
import { NAV_LINKS, SERVICES, COMPANY } from '../data/content';

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-line bg-ink">
    <div className="max-w-[1440px] mx-auto px-6 lg:px-12 pt-20 pb-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
        <div className="lg:col-span-5">
          <Link to="/" className="inline-flex mb-6 bg-white p-3" data-testid="footer-logo" aria-label="Ehimo Building & Civil Engineering — Home">
            <Logo className="h-12 sm:h-14" />
          </Link>
          <p className="text-mute text-sm leading-relaxed max-w-sm">{COMPANY.intro}</p>
          <p className="mt-6 text-xs uppercase tracking-[0.25em] text-white/50">{COMPANY.tagline}</p>
        </div>

        <div className="lg:col-span-2">
          <h3 className="text-xs uppercase tracking-[0.25em] text-mute mb-5">Navigate</h3>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`footer-nav-${l.label.toLowerCase()}`} className="text-sm text-white/80 hover:text-accent transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-2">
          <h3 className="text-xs uppercase tracking-[0.25em] text-mute mb-5">Services</h3>
          <ul className="space-y-3">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <Link to="/services" data-testid={`footer-service-${s.id}`} className="text-sm text-white/80 hover:text-accent transition-colors">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h3 className="text-xs uppercase tracking-[0.25em] text-mute mb-5">Contact</h3>
          <address className="not-italic text-sm text-white/80 space-y-3">
            <p className="leading-relaxed">{COMPANY.address}</p>
            {COMPANY.phones.map((p, i) => (
              <a key={p} href={COMPANY.phoneHrefs[i]} data-testid={`footer-phone-${i}`} className="block hover:text-accent transition-colors">{p}</a>
            ))}
            <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="block text-accent hover:text-accent-dim transition-colors">
              {COMPANY.email}
            </a>
            <p className="text-mute">{COMPANY.hours}</p>
          </address>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-line flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <p className="text-xs text-mute">© {new Date().getFullYear()} Ehimo Building & Civil Engineering Ltd. All rights reserved.</p>
        <Link to="/contact" data-testid="footer-cta" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white hover:text-accent transition-colors">
          Start a Project <ArrowUpRight size={14} />
        </Link>
      </div>
    </div>
  </footer>
);
